import React from "react";
import { Sparkles, UserPlus, LogIn, X, Lock } from "lucide-react";

// Modal shown when a demo user tries to perform any WRITE action.
export default function DemoPromptModal({ detail, onClose, onSignup, onLogin }) {
  const path = (detail?.path || "").replace(/^\//, "");
  return (
    <div
      data-testid="demo-prompt-modal"
      className="fixed inset-0 z-[600] bg-black/75 backdrop-blur-sm grid place-items-center p-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[min(440px,94vw)] rounded-xl overflow-hidden"
        style={{
          background: "linear-gradient(160deg, #12162b, #0c1224)",
          border: "1px solid rgba(251,191,36,0.4)",
          boxShadow: "0 30px 100px rgba(0,0,0,0.7)",
        }}
      >
        <div className="p-5 border-b border-white/8">
          <div className="flex items-center gap-2 mb-1">
            <Lock size={14} className="text-[#fbbf24]" />
            <div className="mono text-[10px] uppercase tracking-[0.28em] text-[#fbbf24]">
              // sign up to continue
            </div>
            <button onClick={onClose} className="ml-auto text-white/50 hover:text-white p-1" data-testid="demo-prompt-close">
              <X size={14} />
            </button>
          </div>
          <div className="text-lg font-medium text-white mt-1">You&apos;re in demo mode</div>
          <div className="text-xs text-white/60 mt-1 leading-relaxed">
            This action needs a real HEXA account so your work is saved and synced.
            Create your free account in seconds — no credit card required.
          </div>
          {path && (
            <div className="mt-2 mono text-[9.5px] text-white/35 uppercase tracking-widest">
              // blocked: {(detail?.method || "").toUpperCase()} {path}
            </div>
          )}
        </div>

        <div className="p-5 space-y-2">
          <button
            data-testid="demo-prompt-signup"
            onClick={onSignup}
            className="w-full py-2.5 rounded flex items-center justify-center gap-2 mono text-[11px] uppercase tracking-widest font-semibold transition"
            style={{
              background: "linear-gradient(90deg, #fbbf24, #f59e0b)",
              color: "#0c1224",
            }}
          >
            <UserPlus size={13} /> Create free account
          </button>
          <button
            data-testid="demo-prompt-login"
            onClick={onLogin}
            className="w-full py-2 rounded flex items-center justify-center gap-2 mono text-[11px] uppercase tracking-widest text-white/85 transition hover:bg-white/5"
            style={{ border: "1px solid rgba(167,139,250,0.4)" }}
          >
            <LogIn size={12} /> Log in to existing account
          </button>
          <button
            data-testid="demo-prompt-continue"
            onClick={onClose}
            className="w-full py-1.5 mono text-[10px] uppercase tracking-widest text-white/50 hover:text-white/80 transition"
          >
            <Sparkles size={10} className="inline mr-1" /> keep exploring demo
          </button>
        </div>
      </div>
    </div>
  );
}
